<script lang="js">
    export let readingbar = {};
    let progress = 0;

    /** Grab Scroll Container Object */
    const calculateReadingBar = () => {
        let scrollContainer = () => { return document.documentElement || document.body; }
        return (scrollContainer().scrollTop / (scrollContainer().scrollHeight - scrollContainer().clientHeight)) * 100;
    }

    if(readingbar){
        progress = calculateReadingBar();
        window.addEventListener('scroll', () => {
            progress = calculateReadingBar();
        });
    }


</script>

{#if readingbar}
    <div id="fab-readingbar"
         style="
            height: { readingbar.module.options.template.children.height.value };
            max-height: { readingbar.module.options.template.children.height.value };
            background: { readingbar.module.options.template.children.background_color.value };
        "
    >
        <div class="fab-readingbar-progress"
             style="
                 height: { readingbar.module.options.template.children.height.value };
                 max-height: { readingbar.module.options.template.children.height.value };
                 background: { (readingbar.template.color) ? readingbar.template.color :
                    readingbar.module.options.template.children.foreground_color.value };
                 transition: width { readingbar.module.options.template.children.transition.value };
                 width: { progress }%;
            "
        ></div>
    </div>
{/if}